import {
  AppBar,
  Card,
  Collapse,
  Divider,
  Grid,
  Toolbar,
  Typography,
} from '@material-ui/core';
import { ColorDynamic, Stack, useUID } from '@superdispatch/ui';
import { Button } from '@superdispatch/ui-lab';
import styled from 'styled-components';
import { AllNotificationsActivity } from '../../core/notifications-settings/AllNotificationsActivity';
import { getPhoneState } from '../../core/notifications-settings/data/LoadboardUserSettingsDTO';
import { NotificationsSettingsFormResult } from '../../core/notifications-settings/data/NotificationsSettingsFormState';
import { NotificationSettingActivity } from '../../core/notifications-settings/NotificationSettingActivity';
import { NotificationSettingContacts } from '../../core/notifications-settings/NotificationSettingContacts';
import { NotificationSettingPhoneWarning } from '../../core/notifications-settings/NotificationSettingPhoneWarning';

const StyledDivider = styled(Divider)`
  margin: 0 -16px;
  background-color: ${ColorDynamic.Silver400};
`;

const StyledCard = styled(Card)`
  padding: 16px;
`;

const Styled1 = styled(AppBar)`
  top: auto;
  bottom: 0;
`;

export function NotificationSettingsForm(
  props: NotificationsSettingsFormResult,
) {
  const {
    isLoading,
    hasDisabled,
    userSettings,
    notificationSettings,
    settingsForm: { values, dirty, resetForm, isSubmitting },
  } = props;

  const companyId = useUID();
  const personalId = useUID();

  if (!notificationSettings.data) {
    return null;
  }

  const phoneState = !userSettings.data
    ? 'valid'
    : getPhoneState(userSettings.data);

  return (
    <Grid container={true} spacing={1}>
      <Grid item={true} xs={12}>
        <StyledCard>
          <AllNotificationsActivity {...props} />
        </StyledCard>
      </Grid>

      <Grid item={true} xs={12}>
        <Collapse in={!hasDisabled}>
          <Stack space="xsmall">
            {(phoneState === 'invalid' || phoneState === 'missing') && (
              <StyledCard>
                <NotificationSettingPhoneWarning state={phoneState} />
              </StyledCard>
            )}

            {values.load_suggested && (
              <StyledCard aria-labelledby={companyId}>
                <Stack space="xsmall">
                  <Typography id={companyId} variant="h3">
                    Company Notifications
                  </Typography>

                  <NotificationSettingActivity
                    name="load_suggested"
                    isLoading={isLoading}
                  />

                  {userSettings.data && (
                    <>
                      <StyledDivider />

                      <NotificationSettingContacts
                        type="carrier"
                        settings={userSettings.data}
                      />
                    </>
                  )}
                </Stack>
              </StyledCard>
            )}

            <StyledCard aria-labelledby={personalId}>
              <Stack space="small">
                <Typography id={personalId} variant="h3">
                  Your Preferences
                </Typography>

                <NotificationSettingActivity
                  name="request_declined"
                  isLoading={isLoading}
                />

                <StyledDivider />

                <NotificationSettingActivity
                  name="saved_search"
                  isLoading={isLoading}
                  phoneState={phoneState}
                />

                {userSettings.data && (
                  <>
                    <StyledDivider />

                    <NotificationSettingContacts
                      type="dispatcher"
                      settings={userSettings.data}
                    />
                  </>
                )}
              </Stack>
            </StyledCard>
          </Stack>
        </Collapse>
      </Grid>

      <Styled1 position="fixed">
        <Toolbar>
          <Grid container={true} spacing={1}>
            <Grid item={true} xs={6} sm="auto">
              <Button
                variant="neutral"
                fullWidth={true}
                onClick={() => {
                  resetForm();
                }}
                disabled={isLoading || isSubmitting || !dirty}
              >
                Reset
              </Button>
            </Grid>

            <Grid item={true} xs={6} sm="auto">
              <Button
                type="submit"
                fullWidth={true}
                pending={isLoading}
                disabled={isSubmitting || !dirty}
              >
                Save
              </Button>
            </Grid>
          </Grid>
        </Toolbar>
      </Styled1>
    </Grid>
  );
}
